import { render } from "./no-data-message.vue?vue&type=template&id=b22bd72a&scoped=true"
import script from "./no-data-message.vue?vue&type=script&lang=js"
export * from "./no-data-message.vue?vue&type=script&lang=js"

import "./no-data-message.vue?vue&type=style&index=0&id=b22bd72a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b22bd72a"]])

export default __exports__